import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaEnvelope, FaLock } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { loginUser } from "../../store/auth/login/reducer";
import { Toaster, toast } from "sonner";

const Login = () => {
  const [Login, setLogin] = useState({
    email: "",
    password: "",
  });

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [errors, setErrors] = useState({
    email: "",
    password: "",
  });

  const handleInput = (event) => {
    setLogin({
      ...Login,
      [event.target.name]: event.target.value,
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const newErrors = {
      email: Login.email ? "" : "Email is required.",
      password: Login.password ? "" : "Password is required.",
    };
    setErrors(newErrors);
    if (!newErrors.email && !newErrors.password) {
      const result = await dispatch(
        // dispatch login action and await structured result
        loginUser(Login.email, Login.password),
      );
      if (result?.success) {
        toast.success("Logged in successfully");
        setLogin({ email: "", password: "" });
        navigate("/nvm-admin/dashboard");
      } else {
        toast.error(result?.message || "Login failed");
      }
    }
  };

  const token = useSelector((state) => state.loginReducer.token);

  useEffect(() => {
    if (token) {
      navigate("/nvm-admin/dashboard");
    }
  }, [token, navigate]);

  return (
    <div
      className="w-full h-screen flex items-center justify-center bg-cover bg-center"
      style={{ backgroundImage: "url(/Login.jpg)" }}
    >
      <Toaster />
      <div className="backdrop-blur-sm  border-2 border-white p-8 rounded-xl shadow-xl max-w-md w-full">
        <form onSubmit={handleSubmit}>
          <h2 className="text-2xl font-bold text-center mb-6 text-[#1e81b0]">
            Admin Login
          </h2>
          <section className="mb-6 text-white">
            <div className="relative flex items-center justify-center">
              <FaEnvelope className="absolute left-4 shadow-lg" />
              <input
                id="email"
                name="email"
                type="email"
                value={Login.email}
                onChange={handleInput}
                className="bg-transparent w-full p-3 pl-12 rounded-lg border-2 border-[#1e81b0] placeholder:text-white focus:outline-none focus:ring-2 focus:ring-[#1e81b0]"
                placeholder="Email"
              />
            </div>
            {errors.email && (
              <p className="text-red-500 text-sm text-center mt-1">
                {errors.email}
              </p>
            )}
          </section>

          <section className="mb-4 text-white">
            <div className="relative flex items-center justify-center shadow-md">
              <FaLock className="absolute left-4" />
              <input
                id="password"
                name="password"
                type="password"
                value={Login.password}
                onChange={handleInput}
                className="bg-transparent placeholder:text-white w-full p-3 pl-12 rounded-lg border-2 border-[#1e81b0] focus:outline-none focus:ring-2 focus:ring-[#1e81b0]"
                placeholder="Password"
              />
            </div>
            {errors.password && (
              <p className="text-red-500 text-center text-sm mt-1">
                {errors.password}
              </p>
            )}
          </section>

          <button
            type="submit"
            className="shadow-md w-full py-3 bg-[#1e81b0] border-2 border-[#1e81b0] text-white font-semibold rounded-lg hover:bg-[#166d9c] focus:outline-none focus:ring-2 focus:ring-[#1e81b0]"
          >
            Log In
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
